import React, { useState } from 'react'; // useEffect taken out
import './App.css';
import './primitives.css';
import './utilities.css';
import ChordList from './ChordList';
import { settings } from './settings';
import { Howl, Howler } from 'howler';

function App() {

	// Set State
	const [chordSettings,] = useState(settings); // missing updateSettings
	const [chords, setChords] = useState(() => {
		let chords = [];
		for (let i = 0; i < chordSettings.numOfChords; i++) {
			chords.push('0');
		}
		return chords;
	});
	const [isShowingAnswer, setShowAnswer] = useState(false);

	const howlObject = {
			src: ["chord-sprite.mp3"],
			preload: true,
			sprite: {
				chord1: [0, 3017],
				chord2: [5000, 3017],
				chord3: [10000, 3017],
				chord4: [15000, 3017],
				chord5: [20000, 3017],
				chord6: [25000, 3017],
				chord7: [30000, 3017]
			}
	};
	
	// Functions
	/*
	const changeSettings = settingsObj => {
		updateSettings(prevSettings => ({
			...prevSettings,
			settingsObj
		}));
	};
	*/

	const randomChordsList = (allChords) => {
		setShowAnswer(false);
		if (chordSettings.allowRepeatChords) {
			console.log('[generateChords] not ready for repeat chords yet.');
		} else {
			// Fisher-Yates algorithm to shuffle array 
			for (let i = allChords.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * i)
				const temp = allChords[i]
				allChords[i] = allChords[j]
				allChords[j] = temp
			}
			console.log('[generateChords] allChords shuffled: ', allChords);
			const questionChords = allChords.slice(0, chordSettings.numOfChords);
			console.log('[generateChords] questionChords: ', questionChords);
			setChords(() => questionChords);
			return questionChords;
		}
	};

	const playChords = (chords, index=0, isPlayAll=true) => {
		const chordSprite = new Howl({
			...howlObject,
			onend: () => {
				if (isPlayAll && index < chords.length - 1) {
					playChords(chords, index + 1)
					}
				}
		});
		console.log('[playChords] playing:', `chord${chords[index]}`);
		chordSprite.play(`chord${chords[index]}`);
	};

	// Click Handlers
	const onRepeatClick = () => {
		Howler.unload();
		console.log('[onRepeatClick] Repeating...');
		playChords(0, chords);
	}
	
	const onAnswerClick = () => {
		setShowAnswer(show => !isShowingAnswer)
	};

	const onPlayClick = () => {
		Howler.unload();
		console.log('[onPlayClick] about to make list');
		const questionChords = randomChordsList(settings.allChords);
		console.log('[onPlayClick] about to play. chords: ', chords);
		playChords(questionChords);
	};

	const onStopClick = () => {
		Howler.unload();
		console.log('[onStopClick]');
	}

	// Debug
	/*
	useEffect(() => {
		//randomChordsList(settings.allChords);
		console.log('[useEffect] chords: ', chords);
		//console.log('[chordSettings]', chordSettings.userSelectedChords); 
		console.log('[useEffect] isShowingAnswer: ', isShowingAnswer);
	}, []);
	*/

	return (
		<div className="stack center">
			<div className="top-stripe"></div>
			<h1 className="App-logo text-align:center">FreshChord<i className="fa fa-leaf"/></h1>
			<h6 className="page-description">
				Welcome to FreshChord. Learn how to recognize chord progressions by ear.
				Inspired by the book&nbsp;
				<a href="http://www.improviseforreal.com" target="new">
					Improvise For Real&nbsp;
				</a>
				by David Reed. Press play to randomly generate a chord progression. 
				See if you can guess what it is.
			</h6>
			<div className="game-display text-align:center">
				<button
					className="play-button btn btn-outline-success"
					onClick={onPlayClick}
				>
					Play <i className="fa fa-play"/>
				</button>
				<button
					className="repeat-button btn btn-outline-warning"
					onClick={onRepeatClick}
				>
					Repeat <i className="fas fa-redo"/>
				</button>
				<button
					className="stop-button btn btn-outline-danger"
					onClick={onStopClick}
				>
					Stop <i className="fa fa-square"></i>
				</button>
				<ChordList 
					chords={chords}
					numOfChords={chordSettings.numOfChords}
					isShowingAnswer={isShowingAnswer}
					playChords={playChords}
				/>
				<button
					className="answer-button btn btn-primary btn-lg"
					onClick={onAnswerClick}
				>
					Show Answer
				</button>
			</div>
			{/* Debugging and Logging
			<div className="chords-debug">
				DEBUG: {chords}<br />
				<button onClick={() => playChords(chords)}>TEST sound</button>
			</div>
			 End Debug */}
		</div>
  
  )    
}

export default App;
